import helpers from './helpers';

if (helpers.elExists(['.jsLazy'])) {
  import( /* webpackChunkName: "lazy" */ './components/lazy');
}

if (helpers.elExists(['.jsDot'])) {
  import( /* webpackChunkName: "clamp" */ './components/clamp');
}

if (helpers.elExists(['.splide'])) {
  import( /* webpackChunkName: "splide" */ './components/splide');
}

if (helpers.elExists(['.jsPanorama'])) {
  import( /* webpackChunkName: "pannellum" */ './components/pannellum');
}

if (helpers.elExists(['.jsAnimation', '.jsAnimationNumber', '[data-aos]'])) {
  import( /* webpackChunkName: "aos" */ './components/aos');
}